<template>
  <rich-suggestion
    ref="suggestion"
    :editor="editor"
    :lookup-function="findMatches"
    plugin-name="suggestion-group"
    matcher-char="+"
    mention-class="badge badge-group"
    mention-type="group"
  >
    <template #default="{ item }">
      <div @click.prevent>
        <group-icon :group="item" show-details :avatar-size="50"></group-icon>
      </div>
    </template>
  </rich-suggestion>
</template>

<script>
  import GroupIcon from './GroupIcon';
  import RichSuggestion from '@/Atoms/RichSuggestion';

  export default {
    name: 'RichSuggestionGroup',

    components: {
      GroupIcon,
      RichSuggestion,
    },

    props: {
      editor: null,
    },

    computed: {
      plugin() {
        return this.$refs.suggestion.plugin;
      },
    },

    data() {
      return {
        cancelSource: null,
      };
    },

    methods: {
      findMatches(query) {
        this.cancelSource && this.cancelSource.cancel();
        this.cancelSource = axios.CancelToken.source();

        return this.$api('suggestions.groups', { version: '1.0', term: query }, {}, this.cancelSource.token)
          .then((response) => {
            return response.data.data.map((group) => ({ ...group, label: group.slug }));
          })
          .catch(() => {});
      },
    },
  };
</script>

<style scoped></style>
